import script from "./SelectImpresaFerroviariaButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectImpresaFerroviariaButton.vue?vue&type=script&setup=true&lang=js"

import "./SelectImpresaFerroviariaButton.vue?vue&type=style&index=0&id=42889290&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42889290"]])

export default __exports__